import { data } from '../../svg/Submission/data';
import { makeIcon } from '../makeIcon';

export const Submission = makeIcon(data, 'submission', 'Submission');

export default Submission;
